import {formatterNumberDecimals} from 'helpers/mathDictionary';

export const columns = [
    {
        "Header": "Fecha",
        "accessor": "date",
        "filterable": true,
        "filterMethod": (filter, row) => { return row.date?.toLowerCase().includes(filter.value.toLowerCase()); }
    },
    {
        "Header": "Planta",
        "accessor": "station",
        "filterable": true,
        "filterMethod": (filter, row) => { return row.station?.toLowerCase().includes(filter.value.toLowerCase()); }
    },
    {
        "Header": "Cliente",
        "accessor": "customer",
        "filterable": true,
        "filterMethod": (filter, row) => { return row.customer?.toLowerCase().includes(filter.value.toLowerCase()); },
    },
    {
        "Header": "Unidad",
        "accessor": "unitName",
        "filterable": true,
        "filterMethod": (filter, row) => {
            return row.unitName?.toLowerCase().includes(filter.value.toLowerCase())
        }
    },
    {
        "Header": "Placas",
        "accessor": "plates",
        "filterable": true,
        "filterMethod": (filter, row) => { return row.plates?.toLowerCase().includes(filter.value.toLowerCase()); }
    },
    {
        "Header": "Km Anterior",
        "accessor": "prevMileage",
        "filterable": true,
    },
    {
        "Header": "Km Actual",
        "accessor": "mileage",
        "filterable": true,
    },
    {
        "Header": "Litros Surtidos",
        "accessor": "quantity",
        "filterable": true,
    },
    {
        "Header": "Precio Unitario",
        "accessor": "price",
        "filterable": true,
        Cell: props => props.value != null ? '$ '+ formatterNumberDecimals(props.value,2) : null,
    },
    {
        "Header": "Total",
        "accessor": "total",
        "filterable": true,
        Cell: props => props.value != null ? '$ '+ formatterNumberDecimals(props.value,2) : null,
    },
]